import { apiSlice } from "services/apiSlice";

export const clientApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createClient: builder.mutation({
      query: (clientData) => ({
        url: "clients",
        method: "POST",
        body: clientData,
      }),
      invalidatesTags: ["Client"],
    }),
    getClients: builder.query({
      query: (companyId) => ({
        url: `clients/company/${companyId}`,
        method: "GET",
      }),
      providesTags: ["Client"],
    }),
    updateClient: builder.mutation({
      query: ({ id, data }) => ({
        url: `clients/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Client"],
    }),
    deleteClient: builder.mutation({
      query: (id) => ({
        url: `clients/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Client"],
    }),
    toggleClientStatus: builder.mutation({
      query: (id) => ({
        url: `clients/${id}/toggle-status`,
        method: "PATCH",
      }),
      invalidatesTags: ["Client"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateClientMutation,
  useGetClientsQuery,
  useUpdateClientMutation,
  useDeleteClientMutation,
  useToggleClientStatusMutation,
} = clientApi;
